import { calculateTooltipPositionWithAnchorElement } from '../utils/calculateTooltipPositionWithAnchorElement';
import { calculateTooltipPositionWithoutAnchorElement } from '../utils/calculateTooltipPositionWithoutAnchorElement';
import { TooltipPosition } from '../schema/Tooltip.types';
import { useLayoutEffect } from 'react';
import { useSetState } from 'mini-hooks/lib/useSetState';
import { UseTooltipPositionArguments } from '../schema/useTooltipPosition.types';
import { useWindowDimensions } from 'mini-hooks/lib/useWindowDimensions';

function useTooltipPosition({
    placement,
    anchorRef,
    toolTip,
    position,
    arrowPosition,
}: UseTooltipPositionArguments): TooltipPosition {
    const [state, setState] = useSetState({ x: 0, y: 0, arrowLeft: 8 });
    const windowDimensions = useWindowDimensions();

    useLayoutEffect(() => {
        if (anchorRef.current) {
            // Cases where anchor element mentioned

            const tooltipPosition = calculateTooltipPositionWithAnchorElement({
                toolTip,
                anchorRef,
                placement,
                windowDimensions,
            });
            setState(tooltipPosition);
        }
    }, [anchorRef.current, toolTip.current, placement, windowDimensions]);

    useLayoutEffect(() => {
        if (!anchorRef.current) {
            // Cases where anchor element not mentioned

            const tooltipPosition = calculateTooltipPositionWithoutAnchorElement({
                placement,
                position,
                toolTip,
                arrowPosition,
            });
            setState(tooltipPosition);
        }
    }, [anchorRef.current, placement, position, toolTip.current, arrowPosition]);
    return state;
}

export { useTooltipPosition };
